if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.isSubmitting = false;
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.isSubmitting || this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }
        this.isSubmitting = true;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        let sectionsToRequest = [];
        if (this.cart) {
          sectionsToRequest = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append("sections", sectionsToRequest.join(','));
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error) {
                            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                                        this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              if (typeof AOS !== "undefined") {
                AOS.init();
              }
            } else {
                            this.cart.renderContents(response);
              if (typeof AOS !== "undefined") {
                AOS.init();
              }
            }
          })
          .catch((e) => {
            console.error(e);
                      })
          .finally(() => {
            this.isSubmitting = false;
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (typeof AOS !== "undefined") {
              AOS.init();
            }
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          if (typeof errorMessage === "object") {
            const formattedMessage = Object.entries(errorMessage)
              .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
              .join(" | ");
            this.errorMessage.textContent = formattedMessage;
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );
  let removedElements = {
    mobile: [],
    desktop: [],
  };
  function removeElementsByScreenSize(container = document) {
    if (window.matchMedia("(max-width: 990px)").matches) {
      document.querySelectorAll(".hide-mobile").forEach((el) => {
        removedElements.desktop.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });
      removedElements.mobile.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.mobile = [];
    } else {
      document.querySelectorAll(".hide-desktop").forEach((el) => {
        removedElements.mobile.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });
      removedElements.desktop.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.desktop = [];
    }
  }
  removeElementsByScreenSize();
  window.addEventListener("resize", removeElementsByScreenSize);
}
class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.initStickyAddToCart();
  }
  disconnectedCallback() {
    this.visibilityObserver?.disconnect();
    this.heightObserver?.disconnect();
    this.visibilityObserver = null;
    this.heightObserver = null;
    document.documentElement.style.paddingBottom = "0";
    this.variantChangeUnsubscriber?.();
    this.variantChangeUnsubscriber = null;
  }
  initStickyAddToCart() {
    this.productImage = this.querySelector(".product-content img");
    this.selectField = this.querySelector('select[name="id"]');
    this.addButton = this.querySelector('button[name="add"]');
    this.mainProductForm = document.querySelector("product-info product-form.product-form");
    if (!this.selectField || !this.addButton || !this.mainProductForm) return;

    this.priceContainer = this.querySelector('.product-content [id^="price-"]');
    this.mainSectionId = this.mainProductForm.closest("product-info")?.dataset.section;

    this.addToCartText = this.addButton.getAttribute("data-add-to-cart");
    this.soldOutText = this.addButton.getAttribute("data-sold-out");

    const syncSelectedVariant = () => {
      const selectedOption = this.selectField.options[this.selectField.selectedIndex];
      if (!selectedOption) return;
      if (this.productImage && selectedOption.dataset.img) {
        this.productImage.setAttribute("src", selectedOption.dataset.img);
      }
      if (selectedOption.getAttribute("data-available") === "false") {
        this.addButton.setAttribute("disabled", "true");
        this.addButton.querySelector("span").textContent = this.soldOutText;
      } else {
        this.addButton.removeAttribute("disabled");
        this.addButton.querySelector("span").textContent = this.addToCartText;
      }
    };

    this.selectField.addEventListener("change", syncSelectedVariant);
    this.mainProductForm
      .querySelector('[name="id"]')
      ?.addEventListener("change", (e) => {
        const value = Number(e.target.value);
        if (!value) return;
        this.selectField.value = String(value);
        syncSelectedVariant();
      });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || !this.mainSectionId) return;
        if (String(data.sectionId) !== String(this.mainSectionId)) return;
        if (data.variant?.id) {
          this.selectField.value = String(data.variant.id);
          syncSelectedVariant();
        }
        this.updatePrice(data.html, data.sectionId);
      });
    }

    syncSelectedVariant();
    this.checkVisibility();
  }
  // v1.1.0: observers report after layout, so loading and scrolling never force a synchronous reflow.
  checkVisibility() {
    if (!this.mainProductForm || this.visibilityObserver) return;
    this.heightObserver = new ResizeObserver(() => {
      this.stickyHeight = this.clientHeight;
      if (this.isOutOfView) document.documentElement.style.paddingBottom = `${this.stickyHeight}px`;
    });
    this.heightObserver.observe(this);
    // One callback can carry several entries (e.g. below the fold, then in view after layout): the last one is current.
    this.visibilityObserver = new IntersectionObserver((entries) => this.applyVisibility(!entries[entries.length - 1].isIntersecting));
    this.visibilityObserver.observe(this.mainProductForm);
  }
  applyVisibility(isOutOfView) {
    this.isOutOfView = isOutOfView;
    this.classList.toggle("show", isOutOfView);
    this.setAttribute("aria-hidden", String(!isOutOfView));
    document.documentElement.style.paddingBottom = isOutOfView ? `${this.stickyHeight || 0}px` : "0";
  }
  updatePrice(html, sectionId) {
    if (!this.priceContainer || !html) return;
    const source = html.getElementById(`price-${sectionId}`);
    if (!source) return;
    this.priceContainer.innerHTML = source.innerHTML;
    this.priceContainer
      .querySelectorAll(".price--large")
      .forEach((element) => element.classList.remove("price--large"));
  }
}
customElements.define("sticky-add-to-cart", StickyAddToCart);
// --- Cart count update handler for Globo app integration ---
// Try immediate execution if DOM already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartUpdateHandler);
} else {
  initCartUpdateHandler();
}
function initCartUpdateHandler() {
  try {
    const cartIconBubble = document.querySelector('#cart-icon-bubble');
    const cartDrawer = document.querySelector('cart-drawer, cart-notification');
    let isUpdatingCart = false;
  // Function: Update header cart count bubble
  function updateCartCount() {
        fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const count = cart.item_count || 0;
        if (!cartIconBubble) {
                    return;
        }
        // Find or create cart-count-bubble element
        let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (count > 0) {
          // Create bubble if it doesn't exist
          if (!cartCountBubble) {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            cartIconBubble.appendChild(cartCountBubble);
                      }
          // Update visible count (only show if < 100) - MUST be first child
          let visibleSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
          if (count < 100) {
            if (!visibleSpan) {
              visibleSpan = document.createElement('span');
              visibleSpan.setAttribute('aria-hidden', 'true');
              // Insert as first child to maintain correct order
              cartCountBubble.insertBefore(visibleSpan, cartCountBubble.firstChild);
            }
            visibleSpan.textContent = count;
          } else if (visibleSpan) {
            visibleSpan.remove();
          }
          // Update hidden span for accessibility - MUST be second child
          let hiddenSpan = cartCountBubble.querySelector('.visually-hidden');
          if (!hiddenSpan) {
            hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            cartCountBubble.appendChild(hiddenSpan);
          }
          hiddenSpan.textContent = `${count} item${count !== 1 ? 's' : ''}`;
          // Don't set display directly - let CSS handle it
          // Only ensure it's not hidden
          if (cartCountBubble.style.display === 'none') {
            cartCountBubble.style.display = '';
          }
                  } else {
          // Hide or remove bubble if cart is empty
          if (cartCountBubble) {
            cartCountBubble.style.display = 'none';
          }
        }
        // Refresh cart drawer contents if it exists
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          const sectionsToRender = cartDrawer.getSectionsToRender();
          // Get section IDs - use 'section' field if available, otherwise 'id'
          const sectionIds = sectionsToRender.map(s => {
            // For cart-drawer, use 'section' field if available, otherwise 'id'
            return s.section || s.id;
          }).filter(Boolean).join(',');
          if (sectionIds) {
            // Use proper Shopify sections API format: /cart?sections=cart-drawer,cart-icon-bubble
            fetch(`${routes.cart_url}?sections=${sectionIds}`)
              .then(r => r.json())
              .then(data => {
                // API returns: { "cart-drawer": "...", "cart-icon-bubble": "..." }
                // But renderContents expects: { sections: { "cart-drawer": "...", "cart-icon-bubble": "..." } }
                const formattedData = data.sections ? data : { sections: data };
                cartDrawer.renderContents(formattedData);
              })
              .catch(err => {
                console.error('Error updating cart drawer:', err);
              });
          }
        }
      })
      .catch(err => console.error('Error updating cart count:', err));
  }
  // Listen for Globo custom events
  document.addEventListener('globo.swatch.added', updateCartCount);
  // Listen for standard cart update event (from product-form on product pages)
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      // Don't update cart drawer if source is cart-items (already updated via updateQuantity)
      // Only update cart count bubble
      if (event.source === 'cart-items') {
        // Only update cart count, not cart drawer (already updated)
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const count = cart.item_count || 0;
            if (cartIconBubble) {
              let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
              if (count > 0) {
                if (!cartCountBubble) {
                  cartCountBubble = document.createElement('div');
                  cartCountBubble.className = 'cart-count-bubble';
                  cartIconBubble.appendChild(cartCountBubble);
                }
                let visibleSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
                if (count < 100) {
                  if (!visibleSpan) {
                    visibleSpan = document.createElement('span');
                    visibleSpan.setAttribute('aria-hidden', 'true');
                    cartCountBubble.insertBefore(visibleSpan, cartCountBubble.firstChild);
                  }
                  visibleSpan.textContent = count;
                } else if (visibleSpan) {
                  visibleSpan.remove();
                }
                let hiddenSpan = cartCountBubble.querySelector('.visually-hidden');
                if (!hiddenSpan) {
                  hiddenSpan = document.createElement('span');
                  hiddenSpan.className = 'visually-hidden';
                  cartCountBubble.appendChild(hiddenSpan);
                }
                hiddenSpan.textContent = `${count} item${count !== 1 ? 's' : ''}`;
                if (cartCountBubble.style.display === 'none') {
                  cartCountBubble.style.display = '';
                }
              } else {
                if (cartCountBubble) {
                  cartCountBubble.style.display = 'none';
                }
              }
            }
          })
          .catch(err => console.error('Error updating cart count:', err));
        return;
      }
      // Update cart count when standard product-form adds item
      updateCartCount();
    });
  }
  // Listen for Globo's main cart update event
  window.addEventListener('globoSwatchProductsUpdateCart', function(e) {
    // Prevent duplicate processing
    if (isUpdatingCart) {
      return;
    }
    isUpdatingCart = true;
    
    // Update cart drawer via renderContents when Globo adds item
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && typeof cartDrawer.getSectionsToRender === 'function') {
      const sectionsToRender = cartDrawer.getSectionsToRender();
      const sectionIds = sectionsToRender.map(s => s.section || s.id).filter(Boolean).join(',');
      if (sectionIds) {
        // Wait a bit for cart to update, then fetch and render
        setTimeout(() => {
          fetch(`${routes.cart_url}?sections=${sectionIds}`)
            .then(r => r.json())
            .then(data => {
              // Format data to match /cart/add.js response format
              // /cart/add.js returns: { sections: {...}, id: ..., quantity: ..., ... }
              // /cart?sections=... returns: { sections: {...} }
              // We need to ensure the format matches what renderContents expects
              const formattedData = data.sections ? data : { sections: data };
              cartDrawer.renderContents(formattedData);
            })
            .catch(err => {
              console.error('[CART-DEBUG] Error updating cart drawer in globoSwatchProductsUpdateCart:', err);
                          });
        }, 600);
      }
    }
    if (e.detail && e.detail.cart) {
      // Update immediately using data from event
      const count = e.detail.cart.item_count || 0;
      if (!cartIconBubble) {
        return;
      }
      let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!cartCountBubble) {
          cartCountBubble = document.createElement('div');
          cartCountBubble.className = 'cart-count-bubble';
          cartIconBubble.appendChild(cartCountBubble);
                  }
        let visibleSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
        if (count < 100) {
          if (!visibleSpan) {
            visibleSpan = document.createElement('span');
            visibleSpan.setAttribute('aria-hidden', 'true');
            // Insert as first child to maintain correct order
            cartCountBubble.insertBefore(visibleSpan, cartCountBubble.firstChild);
                      }
          visibleSpan.textContent = count;
                  } else if (visibleSpan) {
          visibleSpan.remove();
        }
        let hiddenSpan = cartCountBubble.querySelector('.visually-hidden');
        if (!hiddenSpan) {
          hiddenSpan = document.createElement('span');
          hiddenSpan.className = 'visually-hidden';
          cartCountBubble.appendChild(hiddenSpan);
                  }
        hiddenSpan.textContent = `${count} item${count !== 1 ? 's' : ''}`;
        // Force display to ensure visibility (CSS :empty rule might hide it)
        cartCountBubble.style.display = 'flex';
              } else {
        if (cartCountBubble) {
          cartCountBubble.style.display = 'none';
        }
      }
      // Update cart drawer contents
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        const sectionsToRender = cartDrawer.getSectionsToRender();
        // Get section IDs - use 'section' field if available, otherwise 'id'
        const sectionIds = sectionsToRender.map(s => {
          return s.section || s.id;
        }).filter(Boolean).join(',');
        if (sectionIds) {
          fetch(`${routes.cart_url}?sections=${sectionIds}`)
            .then(r => r.json())
            .then(data => {
              // API returns: { "cart-drawer": "...", "cart-icon-bubble": "..." }
              // But renderContents expects: { sections: { "cart-drawer": "...", "cart-icon-bubble": "..." } }
              const formattedData = data.sections ? data : { sections: data };
              cartDrawer.renderContents(formattedData);
            })
            .catch(err => {
              console.error('Error updating cart drawer:', err);
            });
        }
      }
    } else {
            // Fallback: fetch cart data if event doesn't have cart data
      updateCartCount();
    }
    
    // Reset flag after a delay to allow for cart updates to complete
    setTimeout(() => {
      isUpdatingCart = false;
    }, 1000);
  });
  } catch(err) {
    console.error('[CART-DEBUG] Error in initCartUpdateHandler:', err);
  }
}
